// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IUUF","top":"styles_top__2aFeR","left":"styles_left__2q103","description":"styles_description__29LEg"};